import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/shop';
import Diamond from '../diamond';
import {navigate} from '../../../../utils/navigation';

export default () => {
    const {boxes} = useSelector(Selector);

    return (
        <div className="shop">
            <div className="category">
                <div className="category-title">Lucky Shop</div>
                <div className="boxes">
                    {boxes.map((box, key) => {
                        return (
                            <div className="box" key={key} onClick={e => navigate(`/lootbox/${box.key}`)}>
                                <div className="name">{box.name}</div>
                                <div className="image">
                                    <img
                                        src={`${window.location.origin}/source/system/lootbox/boxes/${box.image}.png`}
                                        alt=""
                                        /> 
                                </div>
                                <div className="button">
                                    <span><Diamond /> {box.price}</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}